import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/common.json';
import es from './locales/es/common.json';

const savedLang = localStorage.getItem('lang') || 'es'; // Idioma guardado o español por defecto

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: savedLang, // Idioma inicial
  fallbackLng: 'es', // Idioma de respaldo si falta una traducción
  interpolation: {
    escapeValue: false, // React ya maneja el escape
  },
});

export default i18n;
